import { useCallback } from 'react';
import { playPracticeSound } from '../services/soundEffects';

export default function useCardFlipAudio(enabled = true) {
  return useCallback(() => {
    if (!enabled || document.hidden) return;
    void playPracticeSound('cardFlip', { recoverOnGesture: true });
  }, [enabled]);
}
